import axios from 'axios';

import { type PersonalInfo } from '@jsmdg/cart-library-ts';

async function validatePersonalInformation(personalInformation: PersonalInfo): Promise<unknown> {
    return axios.post('/api/cart/validate-personal-information', personalInformation);
}

export { validatePersonalInformation };
